import { Text, Heading, Img } from "../../components";
import React from "react";

export default function Hero() {
  return (
    <div className="flex justify-center self-stretch">
      <div className="container-xs flex justify-center md:px-5">
        <div className="w-full rounded-[50px] bg-blue_gray-900 shadow-xs overflow-hidden">
          <div className="mb-[248px] flex flex-col gap-10">
            <div className="flex items-start">
              <div className="-ml-12 h-24 w-24 rounded-lg bg-orange-400 rotate-45 shadow-xxl"/>
              <div className="ml-12 mt-12 h-24 w-24 rounded-lg bg-orange-400 rotate-12 shadow-xxl"/>
              <div className="ml-16 -mt-6 h-24 w-24 rounded-lg bg-orange-400 rotate-45 shadow-xxl"/>
              <div className="ml-12 mt-6 h-24 w-24 rounded-lg bg-orange-400 -rotate-6 shadow-xxl"/>
              <div className="ml-8 -mt-12 h-24 w-24 rounded-lg bg-orange-400 rotate-45 shadow-xxl"/>
              <div className="ml-4 mt-16 h-24 w-24 rounded-lg bg-orange-400 -rotate-12 shadow-xxl"/>
              <div className="ml-2 -mt-4 h-24 w-24 rounded-lg bg-orange-400 -rotate-45 shadow-xxl"/>
              <div className="ml-12 mt-8 h-24 w-24 rounded-lg bg-orange-400 rotate-6 shadow-xxl"/>
              <div className="ml-12 mt-4 h-24 w-24 rounded-lg bg-orange-400 -rotate-12 shadow-xxl"/>
              <div className="ml-12 -mt-12 h-24 w-24 rounded-lg bg-orange-400 -rotate-45 shadow-xxl"/>
              <div className="-mr-12 mt-12 h-24 w-24 rounded-lg bg-orange-400 -rotate-45 shadow-xxl"/>
            </div>
            <div className="mx-[294px] flex flex-col items-center md:mx-0">
            <Img
                    src="images/img_1727681018360.png"
                    alt="Image"
                    className="h-48 w-48 object-cover md:ml-0 relative"
                  />
              <Heading size="heading2xl" as="h1" className="text-[96px] font-bold text-white-a700 md:text-[48px]">
                Timo Enserink
              </Heading>
              <Text
                size="textlg"
                as="p"
                className="relative -mt-6 font-normal italic text-orange-400"
              >
                softwareDeveloper
              </Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
